<div class="footer-area">
  <div class="row align-items-center">
    <div class="col-lg-6 col-sm-6 col-md-6 zoom_80">
      <p
        style="float: right; margin-right: 1rem; background-color: transparent"
      >
        Copyright <i class="bx bx-copyright"></i>
        {{ currentDate | date : "yyyy" }} Doqfy. All rights reserved
      </p>
    </div>
  </div>
</div>
